import { createAsyncThunk } from '@reduxjs/toolkit';
import { addLoading, removeLoading } from '../appAction';
import { Enums, Paths, Value } from '@utils/constants';
import { axios } from '@utils/lib';

/** Developer API */
export const getDeveloperListAsync = createAsyncThunk(
  'api/getDeveloperListAsync',
  async (
    { query, hideLoading }: IGetDeveloperApi,
    { rejectWithValue, dispatch },
  ) => {
    const searchQuery: Record<string, string> = {
      'pagination[page]': query.page ?? Value.TABLE_PAGE_INIT,
      'pagination[pageSize]': query.pageSize ?? Value.TABLE_PAGE_SIZE,
      sort: 'id:desc',
    };
    if (query.username)
      searchQuery['filters[username][$contains]'] = query.username;
    if (query.blocked) searchQuery['filters[blocked][$eq]'] = query.blocked;

    const params = new URLSearchParams(searchQuery).toString();
    if (!hideLoading) {
      dispatch(addLoading());
    }
    try {
      const { data } = await axios.request<IListRes<IDeveloperData>>(
        Enums.HTTP_METHOD.GET,
        Paths.DEVELOPERS + '?' + params,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const changeActiveDeveloperAsync = createAsyncThunk(
  'api/changeActiveDeveloperAsync',
  async (body: IChangeActiveDeveloperForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { id } = body;
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.PATCH,
        Paths.DEVELOPER_ACTIVE.replace(':id', id.toString()),
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const registerDeveloperAsync = createAsyncThunk(
  'auth/user',
  async (body: IDeveloperRegisterForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.POST,
        Paths.DEVELOPERS,
        body,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const getDeveloperDetailsAsync = createAsyncThunk(
  'api/getDeveloperDetailsAsync',
  async (id: number | string, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IDataRes<IDeveloperRegisterForm>>(
        Enums.HTTP_METHOD.GET,
        Paths.DEVELOPERS + '/' + id,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const resetDeveloperPasswordAsync = createAsyncThunk(
  'api/resetDeveloperPasswordAsync',
  async (data: IResetPasswordDeveloperForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { id } = data;
    try {
      const { data } = await axios.request<IDataRes<IDeveloperRegisterForm>>(
        Enums.HTTP_METHOD.POST,
        Paths.DEVELOPERS_RESET_PASSWORD.replace(':id', id.toString()),
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
